// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const tokenExFrame: Styleguide["tokenExFrame"] = {};

export default tokenExFrame;
